import Typography from "@/foundation/Typography/V2";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./BookSlotFormWrapper.module.scss";

interface BookSlotFormWrapperProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  upperTitle?: string;
}

const BookSlotFormWrapper: React.FC<BookSlotFormWrapperProps> = ({
  title,
  subtitle,
  children,
  upperTitle,
}) => {
  const cls = classNameGenerator(styles);

  const { showBookSlotModal } = useAppSelector((state) => state.bootCamp);

  const { packageData, showSubtitle } = showBookSlotModal;

  const { title: packTitle, formTitle, formSubtitle } = packageData || {};

  return (
    <div className={cls("bookSlotFormWrapper")}>
      <div className={cls("header")}>
        {upperTitle && <Typography
          variant="heading2"
          className={cls("upperTitle")}
          dangerouslySetInnerHTML={{ __html: upperTitle }}
        />
        }
        <Typography
          variant="heading2"
          className={cls("title")}
          dangerouslySetInnerHTML={{ __html: formTitle || title }}
        />
        {showSubtitle && (subtitle || formSubtitle || packTitle) && (
          <Typography
            variant="paragraph1"
            className={cls("description")}
            dangerouslySetInnerHTML={{
              __html:
                formSubtitle ||
                subtitle ||
                `Book a slot for - <strong>${packTitle}</strong>`,
            }}
          />
        )}
      </div>
      {children}
    </div>
  );
};

export default BookSlotFormWrapper;
